function getSelectValues(select) {
    const result = [];
    const options = select && select.options;
    var opt;

    for (var i = 0, iLen = options.length; i < iLen; i++) {
        opt = options[i];

        if (opt.selected) {
            result.push(opt.value || opt.text);
        }
    }
    return result;
}

window.addEventListener('DOMContentLoaded', function () {
    window.rm.location = {
        markers: [],
        map: null,
        addressList: [],
        bounds: [],
        activeMark: null,
        filters: {},
        icon: {
            active: '/static/i/svg/pin-red.svg',
            normal: '/static/i/svg/pin-black.svg',
        },

        showPupupInfo: function (html, _t) {
            $('.object-card')
                .removeClass('show')
                .removeAttr('style');
            if (_t) {
                const actionPar = $('.js-action-location'),
                    addressSpec = actionPar.find('.address__item');
                if (!_t.hasClass('active')) {
                    addressSpec.removeClass('active');
                    _t.addClass('active');
                    $('body').removeClass('card-open');
                    $('.object-card').removeClass('show  card-fixed').removeAttr('style');
                    if ($(window).width() < 1199) {
                        if ($(window).width() <= 480) {
                            html.removeAttr('style').addClass('card-fixed');
                            $('body').addClass('card-open');
                        } else {
                            html.removeAttr('style').css({
                                'left': '50%',
                                'transform': 'translateX(-50%)',
                                'top': _t.position().top
                            });
                        }
                    } else {
                        if ((_t.offset().left - actionPar.offset().left) < html.width()) {
                            html.removeAttr('style').css({
                                'left': (_t.offset().left - actionPar.offset().left) + 200,
                                'top': _t.position().top
                            });
                        } else {
                            if (((_t.offset().left + _t.width()) - (actionPar.offset().left + actionPar.width())) < html.width()) {
                                html.removeAttr('style').css({
                                    'left': (_t.offset().left - actionPar.offset().left) - html.width() - 50,
                                    'top': _t.position().top
                                });
                            }
                        }
                    }

                    setTimeout(function () {
                        html.addClass('show');
                    }, 400);
                }
            } else {
                html.css('right', '0').addClass('show');
            }
        },
        addressEventHandler: function (e, target, stop) {
            const _t = $(target),
                _tData = _t.data('spec');
            var html = $('.object-card[data-id="' + _tData + '"]');
            if (html.length) {
                this.showPupupInfo(html, _t);
            } else {
                this.getPointData(_tData, _t);
            }
            return false;
        },
        sideEventHandler: function (activeSlide) {
            const _t = $(activeSlide).closest('.js-object-card'),
                _tBannerId = _t.data('id'),
                _tSideId = $(activeSlide).data('side-id');
            window.rm.location.getSideData(_tBannerId, _tSideId, _t);
        },
        getSideData: function (bannerId, sideId, _t) {
            window.rm.location.showMapPreloader();
            $.getJSON('/api_map/point/' + bannerId + '/side/' + sideId + '/', function (resp) {
                if (resp.success) {
                    const info = $(resp.data);
                    _t.find('.object-info').replaceWith(info)
                }
                window.rm.location.hideMapPreloader();
            });
        },
        getPointData: function (id, _t) {
            window.rm.location.showMapPreloader();
            const self = this;
            $.getJSON('/api_map/point/' + id + '/', function (resp) {
                if (resp.success) {
                    const card = $(resp.data);
                    $('.location-tabs').append(card);
                    $(document).trigger('response:point', [$(card).data('id')])
                    $('.object-btn__close', card).on('click', function () {
                        $(this).parents('.object-card').removeClass('show');
                        $('.address__item.active').removeClass('active');
                        return false;
                    });
                    $('.js-scroll[data-anchor]', card).on('click', function () {
                        const anchorItem = $('section[data-anchor-item="' + $(this).data('anchor') + '"]').offset().top;
                        window.rm.main.closeMenu();
                        $("html, body").animate({scrollTop: anchorItem}, 800);
                        return false;
                    });
                    self.showPupupInfo(card, _t);
                }
                window.rm.location.hideMapPreloader();
            });
        },
        getMarkers: function (items) {
            const self = this,
                markers = [];

            items.forEach(function (item) {
                const marker = new ymaps.Placemark([item.lat, item.lng], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: self.icon.normal,
                    iconImageSize: [14, 19],
                    iconImageOffset: [-14, -19],
                });

                marker.events.add(['click'],  function (e) {
                    if (self.activeMark) {
                        self.activeMark.options.set('iconImageHref', self.icon.normal);
                    }

                    var popup = $('.object-card[data-id="' + item.id + '"]');
                    if (!popup.length) {
                        self.getPointData(item.id)
                    } else {
                        self.showPupupInfo(popup)
                    }

                    e.get('target').options.set('iconImageHref', self.icon.active);
                    self.activeMark = e.get('target');
                });
                marker.address = item.address;
                marker.district = item.district;
                marker.collections = item.collections;
                marker.category = item.category;
                marker.id = item.id;
                marker.is_spec = item.is_spec;
                markers.push(marker);
                self.map.geoObjects.add(marker);
            });

            return markers;
        },
        boundsFromPoints: function () {
            var self = this
            const points = this.markers.slice(0)

            if (!points.length) {
                return [];
            }
            var min = points[0].geometry._coordinates.slice(0),
                max = min.slice(0),
                point;
            for (var i = 0, l = points.length; l; ++i, --l) {
                point = points[i].geometry._coordinates;
                if (min[0] > point[0]) min[0] = point[0];
                if (min[1] > point[1]) min[1] = point[1];
                if (max[0] < point[0]) max[0] = point[0];
                if (max[1] < point[1]) max[1] = point[1];
            }
            return [min, max];
        },
        centerMap: function () {
            const self = this;
            var point = self.boundsFromPoints()
            if (!point.length) {
                self.map.setCenter([61.223009, 97.181961])
                self.map.setZoom(4)
                return
            }
            self.map.setBounds(
                point, {
                    checkZoomRange: true,
                    zoomMargin: 50,
                }).then(function () {
                if (self.markers.length < 2)
                    self.map.setZoom(12)
            })
        },
        filterInputChange: function (e, filterKey) {
            var _t = $(e.target);
            var type = _t.attr('type');
            if (type === 'checkbox') {
                const value = _t.prop('checked') ? 'true' : ''
                this.filterChange(filterKey, value)
            }
            if (type === 'text') {
                this.filterChange(filterKey, _t.val())
            }
        },
        filterSelectChange: function (e, filterKey) {
            if (!Array.isArray(this[filterKey])) {
                this[filterKey] = []
            }
            this.filterChange(filterKey, getSelectValues(e.target))
        },
        filterChange: function (filterKey, value) {
            var self = this;
            this.updateFilters(filterKey, value)
            const queryString = this.createQueryString(this.filters)
            this.fetchMap(queryString, function (map) {
                self.updateMapMarkers(map.map_json)
                self.updateAddressList(map.address_list)
            });
            this.setQueryParams(queryString)
        },
        updateFilters: function (filterKey, value) {
            this.filters[filterKey] = value
        },
        createQueryString: function (queryObject) {
            var result = []
            for (var queryKey in queryObject) {
                const queryItem = queryObject[queryKey]
                if (!queryItem.length) {
                    continue;
                }
                if (typeof queryItem === 'string') {
                    result.push(queryKey + '=' + queryItem)
                } else if (Array.isArray(queryItem)) {
                    result.push(queryKey + '=' + queryItem.join(','))
                }
            }
            if (result.length) {
                return '?' + (result.join('&'))
            }
            return ''
        },
        setQueryParams: function (query) {
            window.history.replaceState('', '', window.location.pathname + query)
        },
        parseQueryString: function (queryString) {
            queryString = queryString.replace(/^\?/gi, '')
            if (!queryString.length) {
                return {}
            }
            const queryArray = queryString.split('&')
            const queryObject = {}
            queryArray.forEach(function (item) {
                var queryKey = item.split('=').at(0)
                var queryValue = item.split('=').at(1)
                if (!queryValue) {
                    return
                }
                if (queryKey.includes('[]')) {
                    queryValue = [].concat(queryValue.split(','))
                }
                queryObject[queryKey] = queryValue
            })
            return queryObject
        },
        fetchMap: function (queryString, cb) {
            const self = this;
            self.showMapPreloader()
            $.getJSON('/api_map/map/' + currentCityName + '/' + queryString, function (resp) {
                cb(resp)
                self.hideMapPreloader()
                return resp
            });
        },
        updateMapMarkers: function (mapPoints) {
            if (this.map.geoObjects) {
                this.map.geoObjects.removeAll()
            }
            this.markers = this.getMarkers(mapPoints.items);
            var clusterer = new ymaps.Clusterer({
                preset: 'islands#invertedGrayClusterIcons',
                groupByCoordinates: false,
                clusterDisableClickZoom: false,
                clusterHideIconOnBalloonOpen: false,
                geoObjectHideIconOnBalloonOpen: false,
                hasBalloon: false,
                gridSize: 50
            })

            clusterer.add(this.markers);
            this.map.geoObjects.add(clusterer);

            this.centerMap()
        },
        updateAddressList: function (addressListHtml) {
            $('.js-address-list').remove()
            if (addressListHtml.trim()) {
                $('.location-tabs-item[data-tab-item="addres"]').append($(addressListHtml))
            }
        },
        showMapPreloader: function () {
            const map = $('.js-map-preloader');
            map.fadeIn(300);
        },
        hideMapPreloader: function () {
            const map = $('.js-map-preloader');
            map.fadeOut(300)
        },
        mapInit: function (mapPoints) {
            const self = this;

            if (mapPoints) {
                window.rm.location.showMapPreloader();

                this.map = new ymaps.Map("map", {
                    center: [0, 0],
                    zoom: 10
                });

                $('.address-list').map(function (i, item) {
                    self.addressList = $(item);
                });

                self.updateMapMarkers(mapPoints)

                this.filters = this.parseQueryString(decodeURI(window.location.search));

                window.rm.location.hideMapPreloader();
            }
        },
        fetchAddressList: function (query, cb) {
            $.getJSON(`/api_map/hint/${currentCityName}/?text=` + query, function (resp) {
                cb(resp)
            });
        },
    };
    ymaps.ready(function () {
        const mapElement = document.getElementById('map')
        window.rm.location.mapInit(JSON.parse(mapElement.dataset.init));
    })
})
